import { Component } from '@angular/core';
import { NavigationEnd, Router, RouterEvent } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { routeMap } from './app.settings';
import { LanguageService } from './core/language/services/language.service';
import { BusinessTypeService } from './core/services/business-type.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'Services';

  private activeModule;

  constructor(
    public languageService: LanguageService,
    private router: Router,
    private translate: TranslateService,
    private businessTypeService: BusinessTypeService
  ) {
    const urlPath = window.location.pathname;
    this.activeModule = routeMap.find((el) => el.regex.test(urlPath));
    const lang = this.languageService.init();
    //this.analyticsTracking.init();
    this.router.events.subscribe((event: any) => this.navigationInterceptor(event));
    const internalPath = window.location.pathname.replace(this.activeModule.basePath[lang], '');
    this.router.navigateByUrl(internalPath + window.location.search, {
      skipLocationChange: true,
    });
  }

  private navigationInterceptor(event: RouterEvent): void {
    if (event instanceof NavigationEnd) {
      // Rewrite the url with a prefix if needed.
      let url = this.activeModule.basePath[this.translate.currentLang];
      url += event.urlAfterRedirects === '/' ? '' : event.urlAfterRedirects;
      url += event.urlAfterRedirects.includes('?') ? '' : window.location.search;
      window.history.replaceState({}, '', url);

      // update business type for changing home link, footer privacies, etc.
      this.businessTypeService.updateBusinessType();
    }
  }
}
